module.exports = __webpack_public_path__ + "bf0e6253c78dcd5ffc6a73e15a4e8a30.svg";